"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditCapacity_1 = require("./EditCapacity");
exports.default = EditCapacity_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EditCapacity/index.js
// module id = 771
// module chunks = 8